import React, { useCallback } from "react";
import { SendMessageOptions } from "stream-chat";
import { Message } from "stream-chat";
import { LocalMessage } from "stream-chat";
import { MessageInput, useChannelActionContext, useMessageComposer } from "stream-chat-react";
import { encodeToMp3 } from "stream-chat-react/mp3-encoder";
import { CustomMessageInputFlat } from "./CustomMessageInputFlat";

interface CustomMessageInputProps {
    shouldFocus?: boolean;
}

const CustomMessageInput: React.FC<CustomMessageInputProps> = ({shouldFocus}) => {
    const { sendMessage } = useChannelActionContext('useSubmitHandler');
    const { textComposer } = useMessageComposer();

    const handleSubmit = useCallback(
        async (params: {
          cid: string;
          localMessage: LocalMessage;
          message: Message;
          sendOptions: SendMessageOptions;
        }) => {    
            await sendMessage({ localMessage: params.localMessage, message: params.message, options: params.sendOptions });
            textComposer.setText('');
        },
        [sendMessage],
      );

    return (
        <MessageInput
            focus={shouldFocus}
            maxRows={10}
            overrideSubmitHandler={handleSubmit}
            audioRecordingEnabled={true}
            audioRecordingConfig={{ transcoderConfig: { encoder: encodeToMp3 } }}
            Input={CustomMessageInputFlat}
        />
    )
}

export default CustomMessageInput;